import { z } from 'zod';

export const deviceCodeSchema = z.object({
  deviceCode: z.string(),
  verificationUri: z.string().url(),
  userCode: z.string(),
  expiresIn: z.number(),
});

export type DeviceCodeResponse = z.TypeOf<typeof deviceCodeSchema>;

export const tokenSchema = z
  .object({
    access_token: z.string(),
    refresh_token: z.string(),
    expires_in: z.number(),
  })
  .transform((token) => ({
    accessToken: token.access_token,
    refreshToken: token.refresh_token,
    expiresIn: token.expires_in,
  }));

export const userInfoSchema = z.object({
  userId: z.string().uuid(),
  email: z.string().email(),
});

export type UserInfo = z.TypeOf<typeof userInfoSchema>;

export const getMyAccountSchema = z.object({
  account: z.object({
    slug: z.string(),
    accountId: z.string().uuid(),
    accountOwner: z.string().uuid(),
  }),
});

export const siteAuthSchema = z.object({
  accessToken: z.string(),
  refreshToken: z.string(),
  expiresIn: z.number(),
  issuedAt: z.number(),
});

export type SiteAuth = z.TypeOf<typeof siteAuthSchema>;

export const accountAuthSchema = siteAuthSchema.extend({
  userInfo: userInfoSchema,
});

export type AccountAuth = z.TypeOf<typeof accountAuthSchema>;

export const apiKeyAuthSchema = z.object({
  token: z.string(),
  accountId: z.string().uuid(),
  userInfo: z.object({
    userId: z.string().uuid(),
    email: z.string(),
  }),
});

export type ApiKeyAuth = z.TypeOf<typeof apiKeyAuthSchema>;
